import Swiper from 'swiper/swiper-bundle';
import Slider from './slider';

export default class ProfessionalJourney {
	constructor() {
		const el = document.getElementById('professionalJourney');
		const swiper = new Swiper(el, {
			// Optional parameters
			loop: false,
			slidesPerView: 2,
			slidesPerGroup: 2,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			spaceBetween: 10,
			breakpoints: {
				576: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				992: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			},
			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				dynamicBullets: true,
				dynamicMainBullets: 1,
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
		swiper.init();
		Slider.sliderNavigation(swiper, true);
		Slider.addEventListeners(swiper, true);
		ProfessionalJourney.badgePositioning(el);
	}

	static badgePositioning(el) {
		const badges = el.querySelectorAll('.badge__container');
		let prev = 0;
		for (let i = 0; i < badges.length; i += 1) {
			const badgeIsActive = badges[i].dataset.isActive === 'True';
			if (!badgeIsActive) {
				badges[i].classList.add('badge__inactive');
			}
			const dashedLine = badges[i].querySelector('.dashed-line--horizontal');
			const isProjectBadge = badges[i].dataset.isProjectBadge === 'True';
			let classNr = 0;
			if (i === 0) {
				classNr = 1;
			} else if (!isProjectBadge) {
				classNr = 0;
			} else if (badges[i + 1] !== undefined && badges[i + 1].dataset.isProjectBadge === 'False') {
				switch (prev) {
					case 1:
						classNr = 2;
						break;
					default:
						classNr = 1;
						break;
				}
			} else {
				switch (prev) {
					case 1:
						classNr = 2;
						break;
					case 2:
						classNr = 0;
						break;
					default:
						classNr = 1;
				}
			}
			let parentClass = '';
			switch (classNr) {
				case 0:
					parentClass = 'flex--self-start';
					break;
				case 1:
					parentClass = 'flex--self-center';
					break;
				case 2:
					parentClass = 'flex--self-end';
					break;
				default:
					parentClass = '';
			}
			if (dashedLine) {
				ProfessionalJourney.linePosition(prev, classNr, dashedLine, badges[i]);
			}
			if (i === badges.length - 1) {
				badges[i].insertAdjacentHTML(
					'afterend',
					`<picture>
					<source media="(max-width: 768px)" srcset="/images/dashed-line-1.svg">
					<source media="(min-width: 768px)" srcset="/images/dashed-line-3.svg">
					<img class="dashed-line--horizontal dashed-line--inactive dashed-line--end" src="" alt=""></picture>`
				);
			}
			prev = classNr;
			badges[i].parentElement.classList.add(`${parentClass}`);
		}
	}

	static linePosition(prev, classNr, dashedLine, badge) {
		const line = dashedLine;
		line.className = 'dashed-line--horizontal';
		if (badge.dataset.isActive === 'False') {
			line.classList.add('dashed-line--inactive');
		}
		if (prev === 0 && classNr === 1) {
			line.srcset = '/images/dashed-line-3.svg';
			line.classList.add('dashed-line-3--alt');
		}
		if (prev === 2 && classNr === 0) {
			line.srcset = '/images/dashed-line-2.svg';
			line.classList.add('dashed-line-2');
		}
		if (prev === 1 && classNr === 2) {
			line.srcset = '/images/dashed-line-3.svg';
			line.classList.add('dashed-line-3');
		}
		if (prev === 2 && classNr === 1) {
			line.srcset = '/images/dashed-line-2.svg';
			line.classList.add('dashed-line-2');
		}
	}
}
